export const toBoolean = (value: any) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        return ['true', '1', 'yes', 'on'].includes(normalized);
    }
    if (typeof value === 'number') return value === 1;
    return false;
};
